// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NjigB","fullView":"styles_fullView__1Qzrc"};